var map = {
	".": 28444,
	"./": 28444,
	"./DailyMotion": 48717,
	"./DailyMotion.js": 48717,
	"./Facebook": 9118,
	"./Facebook.js": 9118,
	"./FilePlayer": 98346,
	"./FilePlayer.js": 98346,
	"./Kaltura": 74894,
	"./Kaltura.js": 74894,
	"./Mixcloud": 63093,
	"./Mixcloud.js": 63093,
	"./Mux": 44508,
	"./Mux.js": 44508,
	"./SoundCloud": 29819,
	"./SoundCloud.js": 29819,
	"./Streamable": 59602,
	"./Streamable.js": 59602,
	"./Twitch": 25269,
	"./Twitch.js": 25269,
	"./Vidyard": 15440,
	"./Vidyard.js": 15440,
	"./Vimeo": 93220,
	"./Vimeo.js": 93220,
	"./Wistia": 11358,
	"./Wistia.js": 11358,
	"./YouTube": 87646,
	"./YouTube.js": 87646,
	"./index": 28444,
	"./index.js": 28444,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players": 28444,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/": 28444,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion": 48717,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion.js": 48717,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook": 9118,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook.js": 9118,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer": 98346,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer.js": 98346,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura": 74894,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura.js": 74894,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud": 63093,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud.js": 63093,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux": 44508,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux.js": 44508,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud": 29819,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud.js": 29819,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable": 59602,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable.js": 59602,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch": 25269,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch.js": 25269,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard": 15440,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard.js": 15440,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo": 93220,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo.js": 93220,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia": 11358,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia.js": 11358,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube": 87646,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube.js": 87646,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index": 28444,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index.js": 28444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85456;